"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContainerStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _getMenuAnimation = require("./getMenuAnimation");
var _menuTheme = require("./menuTheme");
const MenuContainerStyled = (0, _styled.default)("div")`
    border-radius: ${_ref => {
  let {
    themeKey,
    layout
  } = _ref;
  return `var(--sds--menu--border-radius--${layout}, ${_menuTheme.menuTheme.borderRadius(themeKey)})`;
}};
    box-shadow: ${_ref2 => {
  let {
    themeKey
  } = _ref2;
  return _menuTheme.menuTheme.boxShadow(themeKey);
}};
    background-color: ${_ref3 => {
  let {
    themeKey
  } = _ref3;
  return _menuTheme.menuTheme.backgroundColor.rest(themeKey);
}};
    flex-direction: column;
    white-space: nowrap;
    display: flex;
    min-width: var(--sds--menu--min-width, ${_ref4 => {
  let {
    applyMinWidth
  } = _ref4;
  return applyMinWidth ? "240px" : "auto";
}});

    // To allow the container's height to be set manually and add a scrollable area.
    overflow-y: auto;

    // To ensure menus show up on top of menu items they might be rendered within.
    z-index: 1;

    // No right/left padding here. The menu items themselves should add the
    // left/right margin so they have the greatest flexibility.
    padding: ${_ref5 => {
  let {
    layout
  } = _ref5;
  return `var(--sds--menu--padding--${layout}, ${_spacing.sizes.xSmall}px 0)`;
}};

    // This removes a bit of a janky outline on the menu itself.
    // The first element in the Menu will automatically be focused so the menu doesn't get focus.
    outline: none;

    opacity: 0;

    // The menu doesn't exist until the target is clicked, which is why this works
    // This could be refactored to target via classname
    &[role="menu"] {
        opacity: 1;
        transition: opacity ${_ref6 => {
  let {
    themeKey
  } = _ref6;
  return _menuTheme.menuTheme.motion.animation(themeKey);
}};
        animation: ${_ref7 => {
  let {
    placement
  } = _ref7;
  return (0, _getMenuAnimation.getMenuAnimation)(placement);
}}
            ${_ref8 => {
  let {
    themeKey
  } = _ref8;
  return _menuTheme.menuTheme.motion.animation(themeKey);
}};
    }
`;
exports.MenuContainerStyled = MenuContainerStyled;
//# sourceMappingURL=MenuContainerStyled.js.map